


















import { Vue, Component } from "vue-property-decorator";
import ChangeUserInfo from "@/views/pages/changeUserInfo.vue";

import { namespace } from "vuex-class";
const authStore = namespace("Auth");
@Component({
  name: "QNav",
  components: {
    ChangeUserInfo,
  },
})
export default class QNav extends Vue {
  @authStore.Getter
  loggingName!: string;

  @authStore.Getter
  getIsOpen!: boolean;

  @authStore.Action
  updateIsOpen!: (status: boolean) => void;

  public showInfo() {
    this.$emit('showUserInfo');
  }
}
